import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { ACADEMIC_PERIODS } from "../../../utils/constants";
import { AcademicPeriodType } from "../../../types/AcademicPeriod";

export const getAcademicPeriods = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${ACADEMIC_PERIODS}?${queryParams.toString()}`;
    return await get<PagedResultsType<AcademicPeriodType>>(url)
};